import React from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";
import catpuresilk from "../../assets/images/catpuresilk.png";
import cattussar from "../../assets/images/cattussar.png";
import catsemitussar from "../../assets/images/catsemitussar.png";
import catpurecotton from "../../assets/images/catpurecotton.png";
import catfancy from "../../assets/images/catfancy.png";
import catraw from "../../assets/images/catraw.png";
import "./CategoryGrid.css";

const categories = [
  {
    id: "pure-silk",
    title: "Pure Silk",
    subtitle: "Timeless Luxury",
    image: catpuresilk,
  },
  {
    id: "tussar-silk",
    title: "Tussar Silk",
    subtitle: "Natural Elegance",
    image: cattussar,
  },
  {
    id: "semi-tussar-silk",
    title: "Semi Tussar Silk",
    subtitle: "Graceful Weaves",
    image: catsemitussar,
  },
  {
    id: "fancy-sarees",
    title: "Fancy Sarees",
    subtitle: "Contemporary Charm",
    image: catfancy,
  },
  {
    id: "pure-cotton",
    title: "Pure Cotton Sarees",
    subtitle: "Effortless Comfort",
    image: catpurecotton,
  },
  {
    id: "art-silk",
    title: "Art Silk Sarees",
    subtitle: "Modern Sophistication",
    image: catraw,
  },
];

const WHATSAPP_NUMBER = "916235523889";

const CategoryGrid = () => {

  const enquireNow = (category) => {
    const message = `Hi VEDHYAS, I'm interested in ${category.title}. Please share the available sarees and details.`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="vedhyas-categories">

      {/* Background glow */}
      <div className="category-orb category-orb-one" />
      <div className="category-orb category-orb-two" />

      {/* Floating lights */}
      <span className="category-light light-1" />
      <span className="category-light light-2" />
      <span className="category-light light-3" />
      <span className="category-light light-4" />

      <div className="categories-container">

        {/* HEADER */}
        <div className="categories-heading">

          <div className="categories-eyebrow">
            <span />
            <Sparkles />
            <b>THE VEDHYAS COLLECTION</b>
            <Sparkles />
            <span />
          </div>

          <h2>
            Sarees for
            <em> Every Moment</em>
          </h2>

          <p>
            Explore thoughtfully curated saree collections,
            from timeless silk weaves to effortless everyday elegance.
          </p>

        </div>


        {/* CATEGORY GRID */}
        <div className="saree-category-grid">

          {categories.map((category, index) => (

            <article
              key={category.id}
              className={`saree-category-card card-${index + 1}`}
            >

              <div className="category-image">

                <img
                  src={category.image}
                  alt={category.title}
                  loading="lazy"
                />

                {/* Gradient */}
                <div className="category-overlay" />

                {/* Moving shine */}
                <div className="category-shine" />

                {/* Glow */}
                <div className="category-image-glow" />

                {/* Number */}
                <span className="category-number">
                  0{index + 1}
                </span>

                {/* Content */}
                <div className="category-content">

                  <span className="category-subtitle">
                    {category.subtitle}
                  </span>

                  <h3>
                    {category.title}
                  </h3>

                  <div className="category-bottom">

                    <button
                      type="button"
                      onClick={() => enquireNow(category)}
                      className="category-enquire-btn"
                      aria-label={`Enquire about ${category.title}`}
                    >
                      <span>
                        Enquire Now
                      </span>

                      <div className="category-arrow">
                        <ArrowUpRight />
                      </div>
                    </button>

                  </div>

                </div>

              </div>

            </article>

          ))}

        </div>


        {/* FOOTER LINE */}
        <div className="categories-footer">

          <div className="footer-line" />

          <span>
            WOVEN WITH ELEGANCE • CURATED BY VEDHYAS
          </span>

          <div className="footer-line" />

        </div>

      </div>
    </section>
  );
};

export default CategoryGrid;